ErrorController.$inject = ['$uibModalInstance', '$scope', 'errorTitle', 'errorMessage', 'useTranslator', 'errorDetails'];
export function ErrorController($uibModalInstance, $scope, errorTitle, errorMessage, useTranslator, errorDetails) {

  $scope.errorTitle = errorTitle;
  $scope.errorMessage = errorMessage;
  $scope.useTranslator = useTranslator;
  $scope.errorDetails = errorDetails;
  $scope.areDetailsShown = false;

  $scope.expandDetails = function() {
    $scope.areDetailsShown = true;
  };

  $scope.ok = function() {
    $uibModalInstance.dismiss('ok');
  };
}
